import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { v4 as uuidv4 } from 'uuid';
import fetchAPI from 'utils/http/fetchAPI';
import { CELL_SETS_CREATE } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import handleError from 'utils/http/handleError';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
import { getHasPermissions } from 'redux/selectors';
import { permissions } from 'const';
import { notAllowedMessage } from 'utils/PermissionsChecker';
var createCellSetJsonMerger = function createCellSetJsonMerger(newCellSet, cellClassKey) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClassKey, "\")]"),
      value: {
        children: [{
          $insert: {
            index: '-',
            value: newCellSet
          }
        }]
      }
    }
  }];
};
var createCellSet = function createCellSet(experimentId, name, color, cellIdsSet) {
  var parentNodeKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'scratchpad';
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error, properties, data, dataForRedux, dataForUpload, _properties$parentNod, rootNodeName;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error, properties = _getCellSets.properties;
            if (getHasPermissions(null, permissions.WRITE)(getState())) {
              _context.next = 4;
              break;
            }
            pushNotificationMessage('error', notAllowedMessage);
            return _context.abrupt("return", null);
          case 4:
            if (!(loading || error)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", null);
          case 6:
            data = {
              key: uuidv4(),
              name: name,
              color: color,
              type: 'cellSets'
            }; // cellIds are stored as an integer set in redux, so we need to convert it
            dataForRedux = _objectSpread(_objectSpread({}, data), {}, {
              parentNodeKey: parentNodeKey,
              cellIds: new Set(cellIdsSet)
            }); // cellIds are stored as an array in S3
            dataForUpload = _objectSpread(_objectSpread({}, data), {}, {
              cellIds: Array.from(cellIdsSet)
            });
            if (!(dataForRedux.cellIds.size === 0)) {
              _context.next = 12;
              break;
            }
            pushNotificationMessage('info', endUserMessages.EMPTY_CLUSTER_NOT_CREATED);
            return _context.abrupt("return");
          case 12:
            dispatch({
              type: CELL_SETS_CREATE,
              payload: dataForRedux
            });
            _context.prev = 13;
            _context.next = 16;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"), {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/boschni-json-merger+json'
              },
              body: JSON.stringify(createCellSetJsonMerger(dataForUpload, parentNodeKey))
            });
          case 16:
            rootNodeName = (_properties$parentNod = properties[parentNodeKey]) === null || _properties$parentNod === void 0 ? void 0 : _properties$parentNod.name;
            pushNotificationMessage('info', endUserMessages.SUCCESS_NEW_CLUSTER_CREATED(rootNodeName));
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](13);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[13, 20]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default createCellSet;